import React, { ReactElement } from 'react';
import MuiTable from 'components/molecules/MuiTable';
import { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables';
import textLabels from 'utils/MUIDataTableTextLabels';
import Chip from '@material-ui/core/Chip';
import { IOrderProducts } from 'interfaces/orderTracking.interface';

interface Props {
  isLoading: boolean;
  order: IOrderProducts[];
}

export default function OrderTrackingList({ isLoading, order }: Props): ReactElement {
  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'id',
      label: 'id',
      options: {
        display: 'false'
      }
    },
    {
      name: 'ocNumber',
      label: 'Número de orden'
    },
    {
      name: 'dropshipper',
      label: 'Nombre del proveedor',
      options: {
        customBodyRender: (value) => {
          return value.name;
        }
      }
    },
    {
      name: 'sku',
      label: 'SKU'
    },
    {
      name: 'name',
      label: 'Producto'
    },
    {
      name: 'quantity',
      label: 'Cantidad'
    },
    {
      name: 'total',
      label: 'Total'
    },
    {
      name: 'id',
      label: '# guía',
      options: {
        customBodyRender: (value) => {
          const product = order.find((product: IOrderProducts) => product.id === value);
          if (product?.trackingNumber) {
            return (
              <Chip
                variant="outlined"
                size="small"
                color="primary"
                label={`${product.trackingNumber}`}
                clickable
                onClick={() => {
                  window.open(`${product.trackingUrl}`);
                }}
              />
            );
          } else {
            return <Chip variant="outlined" size="small" color="primary" label="No enviado" clickable />;
          }
        }
      }
    }
  ];

  const options: MUIDataTableOptions = {
    textLabels,
    download: false,
    filter: false,
    print: false,
    selectableRowsHeader: false,
    selectableRows: 'none',
    viewColumns: false
  };

  return (
    <div>
      <MuiTable title="Listado de Productos" isLoading={isLoading} columns={columns} data={order} options={options} />
    </div>
  );
}
